import { Component, ViewChild, ElementRef } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';

@Component({
  selector: 'app-a2-sales-order-query',
  templateUrl: './a2-sales-order-query.component.html',
  styleUrls: ['./a2-sales-order-query.component.scss']
})
export class A2SalesOrderQueryComponent extends GridBaseCase {

  constructor() { super(); }

}